import { keyBy } from 'lodash';
import topMoverService from '../../../../core/services/Market/TopMover/TopMoverService';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import Const from '../Const';
import currentState from './../../../helpers/CurrentState';
import ConstCommon from './../../../common/Const';
import { handleExport } from '../../../helpers/HandleExport';

const REDUCER_NAME = 'TOP_NEW_LOW:OVERVIEW:';
const FETCH_LIST_OVERVIEW_TABLE = `${REDUCER_NAME}FETCH_LIST_OVERVIEW_TABLE`;
const CHANGE_TIME_RANGE = `${REDUCER_NAME}CHANGE_TIME_RANGE`;
const SUBSCRIBE_REALTIME_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK`;
const UPDATE_CHART_IMAGE = `${REDUCER_NAME}UPDATE_CHART_IMAGE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;

export {
  REDUCER_NAME,
  fetchListTopNewLowTable,
  changeTimeRange,
  cancelFetchListTopNewLowTable,
  subscribeRealtimeTickTopNewLow,
  fetchChartImage,
  changeSortState,
  downloadTopNewLow,
};

function downloadTopNewLow(apiParams, fileName = 'export-file-name') {
  return dispatch => {
    topMoverService.downloadTopNewLow(apiParams).then(response => {
      handleExport(response, fileName);
    });
  };
}

function cancelFetchListTopNewLowTable() {
  return () => {
    Interval.cancel('TopNewLow');
  };
}

function changeSortState(sortState) {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
}

function fetchListTopNewLowTable(filter = 'All', timeRange = 'ThreeMonths') {
  return (dispatch, globalState) => {
    Interval.fetch(
      'TopNewLow',
      dispatch,
      () => {
        timeRange = globalState()[REDUCER_NAME].timeRange || timeRange;
        dispatch(setLoading(true));
        return topMoverService.getDataTopNewLowOverview({
          ComGroupCode: filter,
          TimeRange: timeRange,
        });
      },
      response => {
        if (response) {
          const listDataTopNewLow = response.items || [];
          dispatch({
            type: FETCH_LIST_OVERVIEW_TABLE,
            payload: {
              listDataTopNewLow,
            },
          });
        }
        dispatch(setLoading(false));
      },
      Const.topNewLowInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function changeTimeRange(timeRange, code) {
  return dispatch => {
    dispatch({
      type: CHANGE_TIME_RANGE,
      payload: {
        timeRange,
      },
    });
    dispatch(fetchListTopNewLowTable(code, timeRange));
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function subscribeRealtimeTickTopNewLow(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK,
    payload: {
      data,
    },
  };
}

function fetchChartImage(organCode, theme) {
  return dispatch => {
    topMoverService
      .getTopVolumeChartImage({
        organCode,
        theme,
      })
      .then(({ items }) => {
        dispatch({
          type: UPDATE_CHART_IMAGE,
          payload: {
            organCode,
            image: items ? items[0] : '',
          },
        });
      });
  };
}

const initialState = {
  listDataTopNewLowTicker: [],
  listObjectDataTopNewLowByTicker: {},
  images: {},
  component: {},
  isLoading: false,
  sortState: {},
};

function reducer(globalState = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...globalState,
        ...initialState,
        timeRange:
          currentState.get(ConstCommon.listComponent.TopNewLow, 'timeRange') ||
          Const.defaultTimeRange,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_OVERVIEW_TABLE:
      const listObjectDataTopNewLowByTicker = keyBy(
        action.payload.listDataTopNewLow,
        'organCode',
      );
      const listDataTopNewLowTicker = action.payload.listDataTopNewLow.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDataTopNewLowTicker,
        listObjectDataTopNewLowByTicker,
      };

    case CHANGE_TIME_RANGE:
      const timeRange = action.payload.timeRange;
      currentState.add(
        ConstCommon.listComponent.TopNewLow,
        'timeRange',
        timeRange,
      );
      return { ...globalState, timeRange };

    case SUBSCRIBE_REALTIME_TICK:
      const listObjectDataTopNewLowByTickerNew = {
        ...globalState.listObjectDataTopNewLowByTicker,
      };

      action.payload.data.forEach(item => {
        if (listObjectDataTopNewLowByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listObjectDataTopNewLowByTickerNew[item.organCode],
          };

          if (tickerItem) {
            tickerItem.volume = item.totalMatchVolume;
            tickerItem.price = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
            tickerItem.performance.percentPriceChange1Day =
              item.percentPriceChange;
          }
          listObjectDataTopNewLowByTickerNew[item.organCode] = tickerItem;
        }
      });

      return {
        ...globalState,
        listObjectDataTopNewLowByTicker: listObjectDataTopNewLowByTickerNew,
      };

    case UPDATE_CHART_IMAGE:
      return {
        ...globalState,
        images: {
          ...globalState.images,
          [action.payload.organCode]: action.payload.image,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case SET_LOADING:
      return {
        ...globalState,
        isLoading: action.payload,
      };

    case CHANGE_SORT_STATE:
      return {
        ...globalState,
        sortState: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
